import { useStores } from "../../../../core/stores/rootStore";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { action } from "mobx";
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import Card from 'react-bootstrap/Card';
import 'react-toastify/dist/ReactToastify.css';
import DateFormatted from './../../../../shared/components/dateFormatted';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Skeleton from 'react-loading-skeleton';
import { isNumberKey, isZeroOne, getDayNameFromDate, formatMonthYear, lpad, setConfig, getLocalizedCountryFromCurrency, isImage, isPDF, allowedExtensions } from './../../../../utils';
import moment from 'moment';
import Stack from 'react-bootstrap/Stack';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { confirm } from "../../../../components/modal/confirmation"
import Button from 'react-bootstrap/Button';
import { saveAs } from 'file-saver';
import Table from 'react-bootstrap/Table';
import FormFileUpload from "./../../../inputs/fileupload";
import Spinner from 'react-bootstrap/Spinner';
import { NumericFormat } from 'react-number-format';
import NumberFormatted from './../../../../shared/components/numberFormatted';
import Modal from 'react-bootstrap/Modal';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
} from "@progress/kendo-react-intl";

const ExpensesWithCostsForm = () => {

    let navigate = useNavigate();
    const { year, month, currencyId, devId } = useParams();
    const { t, i18n } = useTranslation();
    const { expensesWithCostsFormStore, utilsStore, fileStore, loginStore } = useStores();
    const { accountInfo } = loginStore;
    const { add, remove, save, updateVat, getCostsExpense,
        isLoading, criteria, costsExpense, getTotal, getTotalVAT, getConvertedAmount, canEdit, isLocalCurrency,
        showWarningAllowance, setAttachment, updateExchangeRate, isSelectedCurrencyIsTheSameAsTheExpense, updateExchangeRateManually } = expensesWithCostsFormStore;
    const {
        getCostsExpensesCategories, costsExpensesCategories,
        //getExchangeRates, exchangeRates,
        getCountryCurrencies, countryCurrencies,
        getExpenseVATs, expenseVatSettings,
    } = utilsStore;
    const { uploadAttachment, getAttachmentFile } = fileStore;
    const inputRef = useRef([]);
    const [isUploading, setIsUploading] = useState(null);

    const getVATS = (expenseId) => {
        var vats = expenseVatSettings.filter(x => !x.archived);

        //If archived is selected, add to list anyway
        var currentVat = expenseVatSettings.find(x => x.id === expenseId);
        if (currentVat && !vats.find(x => x.id === currentVat?.id))
            vats.push(currentVat);

        return vats?.sort((a, b) => Number(a.tax) - Number(b.tax));
    };

    const [fileLoading, setFileLoading] = useState(null);
    const [pdfData, setPdfData] = useState(null);
    const [showReport, setShowReport] = useState(false);
    const closeShowReport = () => {
        setPdfData(null);
        setShowReport(false);
    }

    const showFile = (result, attachment) => {
        var fileReader = new FileReader();
        fileReader.onload = function (event) {
            setPdfData({
                id: attachment?.id,
                data: event.target.result,
                filename: attachment?.filename,
            });
        };
        fileReader.readAsArrayBuffer(result.bytes);
        setShowReport(true);
    }

    useEffect(() => {
        Promise.all([getCostsExpense(year, month, currencyId, devId), getCostsExpensesCategories(devId), getCountryCurrencies(), getExpenseVATs()/*,getExchangeRates(year,month)*/]);
    }, []);

    return (
        <div>
            <Modal className="modal-xl" show={showReport} onHide={() => closeShowReport()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Stack direction="horizontal" gap={3}>
                            {pdfData?.filename}

                            {isImage(pdfData?.filename) && <Button style={{ height: 30, width: 30, }} disabled={isLoading} className="float-end btn btn-secondary" type="button" size="sm"
                                onClick={async () => {
                                    setFileLoading({ id: pdfData?.id });
                                    await getAttachmentFile(pdfData?.id).then((b) => saveAs(new Blob([b.bytes]), pdfData?.filename));
                                    setFileLoading(null);
                                }}>

                                {fileLoading && fileLoading?.id === pdfData?.id ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={solid("download")} size="sm" />}
                            </Button>}
                        </Stack>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(pdfData && isImage(pdfData?.filename)) &&
                        <Stack><img style={{ height: "75vh", objectFit: "contain" }} src={URL.createObjectURL(new Blob([pdfData?.data]))} alt={pdfData?.filename} /></Stack>
                    }
                    {pdfData && isPDF(pdfData?.filename) && <LocalizationProvider language={i18n.language}><PDFViewer style={{ height: pdfData ? "75vh" : null }}
                        saveFileName={pdfData?.filename}
                        arrayBuffer={pdfData?.data} tools={["pager", "spacer", "zoomInOut", "zoom", "selection", "spacer", "search", "download"]}
                    /></LocalizationProvider>}
                </Modal.Body>
            </Modal>

            <form onSubmit={save}>
                <Card>
                    <Card.Body>
                        <Row>
                            <Col xs={4}>
                                <div style={{ alignSelf: "center" }}>
                                    <ArrowBackIosIcon disabled={isLoading} sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate(-1)} size="small" />
                                </div>
                            </Col>
                            <Col xs={4} className="text-center">
                                {isLoading ? <Skeleton width={300} /> : <h5>{formatMonthYear(new Date(criteria.year, criteria.month - 1, 1))} - {t("expenseWithCosts")} ({costsExpense?.currency?.shortName})</h5>}
                                {(costsExpense?.items?.some(expense => showWarningAllowance(expense) && costsExpense?.currency?.shortName === "CHF" && costsExpense?.representativeAllowance)) ? <span style={{ color: "orange" }}>{t("lowExpense")}</span> : ""}
                            </Col>
                            <Col xs={4}>

                                <Stack direction="horizontal" gap={2}>
                                    <span className="ms-auto" />

                                    <button disabled={isLoading} className="float-end btn btn-danger" type="button"
                                        onClick={() => navigate(-1)}>
                                        {t('cancel')}
                                    </button>


                                    {canEdit && <button disabled={isLoading} className="float-end btn btn-secondary" type="button"
                                        onClick={() => { add() }}>
                                        <FontAwesomeIcon icon={solid("plus")} />
                                    </button>}

                                    {canEdit && <button disabled={isLoading || !canEdit} className="float-end btn btn-secondary" type="submit"
                                    /*onClick={() => { save() }}*/>
                                        {t('save')}
                                    </button>}
                                </Stack>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Card className="mt-2 cost-expense-list">
                    <Card.Body>


                        <Table className="table" size="sm">
                            <thead>
                                <tr>
                                    <th style={{ width: '0%' }}>Ticket Nº</th>
                                    <th style={{ width: '5%' }}>{t('date')}</th>
                                    <th style={{ width: '20%' }}>{t('description')}</th>
                                    <th style={{ width: '10%' }}>{t('category')}</th>
                                    <th style={{ width: '10%' }}>{t('localCurrencyAmount')}</th>
                                    <th style={{ width: '10%' }}>{t('currency')}</th>
                                    <th style={{ width: '10%' }}>{t('vat')}</th>
                                    <th style={{ width: '10%' }}>{t('localCurrencyVATAmount')}</th>
                                    <th style={{ width: '10%' }}>{t('rate')}</th>
                                    <th style={{ width: '10%' }}>{t('amountInCurrency', { param: costsExpense?.currency?.shortName })}</th>
                                    <th style={{ width: '10%' }}>{t('vatAmount')}</th>
                                    <th style={{ width: '5%' }}>{t('file')} ({allowedExtensions})</th>
                                    <th style={{ width: '0%' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    isLoading ?
                                        (
                                            Array.from(Array(30), (e, i) => {
                                                return <tr key={i}>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                </tr>
                                            })
                                        )
                                        :
                                        costsExpense?.items?.map((expense, index) => (
                                            <tr key={index} style={{ verticalAlign: "middle" }}>
                                                <td>{lpad(index + 1, 3)}</td>
                                                <td>
                                                    <Stack direction="horizontal" >
                                                        <span style={{ width: 40 }}>{expense.date ? getDayNameFromDate(moment(expense.date).toDate()) : "-"}</span>
                                                        <input
                                                            disabled={!canEdit}
                                                            required
                                                            className="form-control"
                                                            value={expense.date?.substr(0, 10)}
                                                            style={{ width: 100 }}
                                                            type="date"
                                                            onChange={action((e) => {
                                                                expense.date = e.target.value;
                                                                updateExchangeRate(expense).then(() => {
                                                                    expense.diff = 0;
                                                                    updateVat(expense, expenseVatSettings);
                                                                });
                                                            })} />
                                                    </Stack>
                                                </td>
                                                <td>
                                                    <input
                                                        disabled={!canEdit}
                                                        required
                                                        placeholder={t("enterValue")}
                                                        className="form-control"
                                                        value={expense.description ?? ""}
                                                        type="text"
                                                        onChange={action((e) => { expense.description = e.target.value; })} />
                                                </td>
                                                <td>
                                                    <select
                                                        disabled={!canEdit}
                                                        required
                                                        className="form-control"
                                                        value={expense.expenseId}
                                                        onChange={action((e) => { expense.expenseId = e.target.value; })} >
                                                        <option value="">{t("enterValue")}</option>
                                                        {costsExpensesCategories?.map((c, index) =>
                                                            <option key={index} value={c.id}>{i18n.language === "fr" ? c.nameFR : c.nameEN}</option>
                                                        )}
                                                    </select>
                                                </td>
                                                <td>
                                                    <NumericFormat
                                                        style={{ textAlign: "right" }}
                                                        disabled={!canEdit}
                                                        required

                                                        className="form-control"
                                                        placeholder={t("enterValue")}

                                                        value={expense.amount}
                                                        onValueChange={action((values, sourceInfo) => {
                                                            expense.amount = values?.floatValue ?? "";
                                                            expense.diff = 0;
                                                            updateVat(expense, expenseVatSettings);
                                                        })}

                                                        valueIsNumericString={true}
                                                        fixedDecimalScale
                                                        decimalScale={2} allowLeadingZeros={false} thousandSeparator="'" decimalSeparator="."

                                                    />
                                                </td>
                                                <td>

                                                    <select
                                                        disabled={!canEdit}
                                                        required
                                                        className="form-control"
                                                        value={expense.currencyId}
                                                        onChange={action((e) => {

                                                            expense.currencyId = e.target.value;
                                                            expense.diff = 0;
                                                            if (!isLocalCurrency(countryCurrencies, expense.currencyId)) {
                                                                expense.vatAmount = null;
                                                            }

                                                            updateExchangeRate(expense).then(() => 
                                                                updateVat(expense, expenseVatSettings)
                                                            );
                                                        })} >
                                                        <option value="">{t("enterValue")}</option>
                                                        {countryCurrencies?.map((c, index) =>
                                                            <option key={index} value={c.id}>{`${c.code.toUpperCase()} - ${getLocalizedCountryFromCurrency(c)}`}</option>
                                                        )}
                                                    </select>
                                                </td>
                                                <td>
                                                    <select
                                                        //required={isLocalCurrency(countryCurrencies,expense.currencyId)}
                                                        disabled={!canEdit}
                                                        className="form-control"
                                                        value={expense.expenseVatRateId ?? ''}
                                                        onChange={action((e) => {
                                                            expense.expenseVatRateId = e.target.value;
                                                            expense.diff = 0;
                                                            updateVat(expense, expenseVatSettings);
                                                        })} >
                                                        <option value="">{isLocalCurrency(countryCurrencies, expense.currencyId) ? t("enterValue") : ""}</option>
                                                        {getVATS(expense.expenseVatRateId)?.map((c, index) =>
                                                            <option disabled={c.archived} key={index} value={c.id}>{`${c.tax} % ${c.archived ? `(${t("archived")})` : ""}`}</option>
                                                        )}
                                                    </select>
                                                </td>

                                                <td>
                                                    {expense?.rateLoading ? <Skeleton /> :
                                                        <NumericFormat
                                                            style={{ textAlign: "right" }}
                                                            disabled={!expense.expenseVatRateId || !canEdit}
                                                            required={!!expense.expenseVatRateId}
                                                            placeholder={t("enterValue")}
                                                            className="form-control"
                                                            value={expense.localCurrencyVATAmount ?? ''}

                                                            onValueChange={action((values, sourceInfo) => {

                                                                if (expense.localCurrencyVATAmount) {
                                                                    expense.vatAmount = values?.floatValue.toFixed(2) * expense.exchangeRate;
                                                                }

                                                                expense.localCurrencyVATAmount = values?.floatValue.toFixed(2) ?? "";
                                                            })}

                                                            valueIsNumericString={true}
                                                            fixedDecimalScale
                                                            decimalScale={2} allowLeadingZeros={false} thousandSeparator="'" decimalSeparator="."
                                                        />
                                                    }
                                                </td>

                                                <td>
                                                    {expense?.rateLoading ? <Skeleton /> : <NumericFormat
                                                        style={{ textAlign: "right" }}
                                                        disabled={!canEdit || isSelectedCurrencyIsTheSameAsTheExpense(countryCurrencies, expense.currencyId, costsExpense?.currency?.shortName)}
                                                        required

                                                        className="form-control"
                                                        placeholder={t("enterValue")}

                                                        value={expense.exchangeRate ?? ''}
                                                        onValueChange={action((values, sourceInfo) => {
                                                            expense.exchangeRate = values?.floatValue ?? "";
                                                            updateVat(expense, expenseVatSettings);
                                                        })}

                                                        valueIsNumericString={true}
                                                        fixedDecimalScale
                                                        decimalScale={6} allowLeadingZeros={false} thousandSeparator="'" decimalSeparator="."

                                                    />}
                                                </td>

                                                <td>
                                                    <Stack direction="horizontal" gap={2}>
                                                        <span className="ms-auto" />
                                                        {(showWarningAllowance(expense) && costsExpense?.currency?.shortName === "CHF" && costsExpense?.representativeAllowance)
                                                            && <FontAwesomeIcon icon={solid("warning")} color="orange" title={t("lowExpense")} />}
                                                        <NumberFormatted number={getConvertedAmount(expense)} />
                                                    </Stack>


                                                </td>

                                                <td style={{ textAlign: "right" }}>
                                                    <NumberFormatted number={expense.vatAmount} />
                                                    {/*<NumericFormat*/}
                                                    {/*    style={{ textAlign: "right" }}*/}
                                                    {/*    disabled={true}*/}
                                                    {/*    required={isLocalCurrency(countryCurrencies, expense.currencyId)}*/}
                                                    {/*    placeholder={isLocalCurrency(countryCurrencies, expense.currencyId) ? t("enterValue") : ""}*/}
                                                    {/*    className="form-control"*/}
                                                    {/*    value={expense.vatAmount ?? ''}*/}

                                                    {/*    onValueChange={action((values, sourceInfo) => {*/}
                                                    {/*        expense.vatAmount = values?.floatValue ?? "";*/}
                                                    {/*    })}*/}

                                                    {/*    valueIsNumericString={true}*/}
                                                    {/*    fixedDecimalScale*/}
                                                    {/*    decimalScale={2} allowLeadingZeros={false} thousandSeparator="'" decimalSeparator="."*/}

                                                    {/*/>*/}
                                                </td>

                                                <td>
                                                    <Stack direction="horizontal" gap={1}>


                                                        <FormFileUpload label={expense.attachment?.filename ?? ""} isUploading={isUploading} disabled={!canEdit} hideHover compact id="file" isLoading={isLoading} innerText={t("dragDropDocuments")} accept={allowedExtensions}
                                                            onFileSelected={
                                                                async (f) => {
                                                                    if (isUploading)
                                                                        return;

                                                                    var file = f[0];
                                                                    var data = new FormData();
                                                                    data.append('file', file);
                                                                    setIsUploading({ id: index });
                                                                    var fileId = await uploadAttachment(data);

                                                                    setIsUploading(null);

                                                                    if (Number(fileId) > 0)
                                                                        setAttachment(expense, { id: Number(fileId), filename: file.name })
                                                                }
                                                            }
                                                        />

                                                        {isUploading && expense && isUploading?.id === index && <Spinner animation="border" role="status" size="sm" />}

                                                        {expense.attachment?.id && canEdit && <Button style={{ height: 30, width: 30, }} disabled={isLoading || (isUploading?.id === index)} className="float-end btn btn-secondary" type="button" size="sm"
                                                            onClick={async () => {
                                                                if (expense.attachment?.id)
                                                                    setAttachment(expense, null);
                                                                else
                                                                    inputRef?.current[index]?.click()
                                                            }}>
                                                            <FontAwesomeIcon icon={solid("xmark")} />
                                                        </Button>}

                                                        {expense.attachment?.id && <Button style={{ height: 30, width: 30, }} disabled={isLoading || (isUploading?.id === index)} className="float-end btn btn-secondary" type="button" size="sm"
                                                            onClick={async () => {
                                                                var file = expense?.attachment;
                                                                setFileLoading({ id: file?.id });
                                                                await getAttachmentFile(file?.id).then((b) => showFile(b, file));
                                                                setFileLoading(null);
                                                            }}>
                                                            {fileLoading && fileLoading?.id === expense?.attachment?.id ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={solid("eye")} size="sm" />}
                                                        </Button>}

                                                    </Stack>

                                                </td>

                                                <td style={{ verticalAlign: "middle" }}>


                                                    {canEdit && <Button style={{ height: 30, width: 30, }} disabled={isLoading} className="float-end btn btn-secondary" type="button" size="sm"
                                                        onClick={async () => {
                                                            if (await confirm(t("confirmDelete")))
                                                                remove(index)
                                                        }}>
                                                        <FontAwesomeIcon icon={solid("trash")} />
                                                    </Button>}

                                                </td>

                                            </tr>
                                        ))
                                }
                            </tbody>
                            {<tfoot>
                                <tr>
                                    <td colSpan={9}><b>{t('total')}</b></td>
                                    <td style={{ textAlign: "end" }}><b><NumberFormatted number={getTotal} /></b></td>
                                    <td style={{ textAlign: "end" }}><b><NumberFormatted number={getTotalVAT} /></b></td>
                                </tr>
                            </tfoot>}
                        </Table>

                    </Card.Body>
                </Card>
            </form>
        </div>
    );
};

export default observer(ExpensesWithCostsForm);
